export interface ILinkReferralAccount {
  senderFirstName: string;
}

export interface ILinkReferralAccountApi {
  senderFirstName: string;
}

export enum ReferralStatus {
  Paid = 'paid',
  NotPaid = 'not paid',
}

export interface IReferrer {
  id: string;
  name: string;
  status: ReferralStatus;
}

export interface IGetReferrerResponse {
  referrer: IReferrer | null;
}
